// Deprecated
export const SUTTON = 'SUTTON';
export const CRB = 'CRB';
export const BANCORP = 'BANCORP';
export const PATHWARD = 'PATHWARD';

// Deprecated
export const PCL_CARD_ISSUANCE_BANKS = [CRB, BANCORP, PATHWARD];
export const PCL_CARD_ISSUING_BANKS = [CRB, BANCORP, PATHWARD];
//# sourceMappingURL=issuing-bank.js.map